import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import SearchInputField from '../SearchInputField';
import { InputTypes } from '../../utils/validateFormElement';
import SelectComponent from '../SelectComponent';
import ConfirmationModal from '../ConfirmationModalComponent';
import FormComponent from '../FormComponent';

const CLICK_EVENT = 'click';
const HIDDEN_CLASS = 'u-hidden';
const FLEX_CLASS = 'u-flex';

const SELECTOR_DATA = {
	id: 1,
	step: 1,
	questionType: 'select',
	errorMessage: 'Please select the role for this venue',
	fieldName: 'role',
	placeholder: 'Please Select',
	default: false,
	visible: true,
	allowReset: false,
	label: 'What role do you have at this venue?',
	value: 'Assistant Coach',
	options: [
		{
			id: 'assistantCoach',
			label: 'Assistant Coach'
		},
		{
			id: 'coach',
			label: 'Coach'
		},
		{
			id: 'headCoach',
			label: 'Head Coach'
		},
		{
			id: 'tennisOperator',
			label: 'Operator'
		}
	]
};

class AffiliatedVenueSearch extends FormComponent {
	constructor(containerElement, data) {
		super(containerElement, data);
		this.containerEl = containerElement;
		this._addCallbacks = [];
		this._removeCallbacks = [];
		this._changeRoleCallbacks = [];
	}

	onAddCard(callback) {
		this._addCallbacks.push(callback);
	}

	addAffiliatedCard(data) {
		for (const callback of this._addCallbacks) {
			callback(data);
		}
	}

	onRoleChange(callback) {
		this._changeRoleCallbacks.push(callback);
	}

	roleChangeHandler(data) {
		for (const callback of this._changeRoleCallbacks) {
			callback(data);
		}
	}

	onRemoveCard(callback) {
		this._removeCallbacks.push(callback);
	}

	removeAffiliatedCard(id) {
		for (const callback of this._removeCallbacks) {
			callback(id, this.data);
		}
	}

	markup(value, rowData, titleMarkup) {
		return `
            <div class="lta-park-finder lta-park-finder-${this.data?.id} u-mb-5">
				<div class="lta-park-finder-title u-hidden">${titleMarkup}</div>
                <div class="lta-park-finder--search-input-wrapper">
					<div class="lta-park-finder--search-input"></div>
					<div class="lta-park-finder--search-form-button-wrapper u-flex">
						<a class="lta-park-finder--search-form-button lta-btn lta-btn--lg lta-btn--link u-text-lta-blue" href="${this?.data?.redirectURL}">Can’t find your venue? Contact us</a>
					</div>
				</div>
				<div class="lta-park-finder--search-result u-hidden"></div>
                <div class="lta-park-finder--roles u-hidden"></div>
            </div>
        `;
	}

	renderTitle(title) {
		return title ? `<div class="lta-heading-title u-mb-5 sm:u-mb-3">${title}</div>` : '';
	}

	afterRender() {
		this.parkFinderElement = SelectorEngine.findOne(`.lta-park-finder-${this.data?.id}`, this.containerEl);
		this.parkFinderTitle = SelectorEngine.findOne('.lta-park-finder-title', this.parkFinderElement);
		this.parkFinderSearchInputWrapper = SelectorEngine.findOne(
			'.lta-park-finder--search-input-wrapper',
			this.parkFinderElement
		);
		this.parkFinderSearchInput = SelectorEngine.findOne(
			'.lta-park-finder--search-input',
			this.parkFinderSearchInputWrapper
		);
		this.parkFinderSearchResult = SelectorEngine.findOne('.lta-park-finder--search-result', this.parkFinderElement);
		this.parkFinderRoleElement = SelectorEngine.findOne('.lta-park-finder--roles', this.parkFinderElement);
		this.initSearchInputField();
	}

	initConfirmationModal(resultDetails) {
		this.confirmationModal = new ConfirmationModal(this.parkFinderElement, {
			data: {
				id: 'js-remove-venue-confirmation-checkout',
				show: false,
				title: 'remove this venue?',
				actionButtonId: resultDetails?.venueID,
				primaryButtonLabel: 'Yes, remove the venue',
				secondaryButtonLabel: 'No, keep the venue',
				primaryButtonClick: (event) => {
					this.parkFinderElement?.remove();
					this.removeAffiliatedCard(event.target.id);
				},
				secondaryButtonClick: () => {}
			}
		});
	}

	initSearchInputField() {
		this.searchInputTextField = new SearchInputField(this.parkFinderSearchInput, {
			data: this.data
		});
		this.searchInputTextField.dataMapping = (item) => {
			return {
				firstLineText: item?.venue,
				dataKey: this.data.dataKey,
				dataValue: item.id
			};
		};
		this.searchInputTextField.filterDataMapping = (item, event) => {
			return item.id === event[this.data.dataKey];
		};
		this.searchInputTextField.searchInputMappingChange();
		this.searchInputTextField.onChange((event) => {
			this.loadParkResult(event.value, true);
			this.toggleRoleSelector();
		});
		this.setupValidateObject();
		if (this.data) {
			this.loadParkResult(this.data, false);
		}
	}

	loadParkResult(resultDetails, isSetupValueObject) {
		if (isSetupValueObject) {
			this.setupValueObject(resultDetails, 'Complete');
			this.addAffiliatedCard(resultDetails);
		}
		if (!resultDetails?.venue) {
			return;
		}
		this.createSelectComponent(resultDetails);
		this.initConfirmationModal(resultDetails);
		this.parkFinderSearchInputWrapper.classList.add(HIDDEN_CLASS);
		this.parkFinderTitle.classList.remove(HIDDEN_CLASS);
		this.parkFinderSearchResult.classList.remove(HIDDEN_CLASS);
		this.parkFinderSearchResult.insertAdjacentHTML('beforeend', this.renderAutoSuggestResult(resultDetails));
		this.afterAutoSuggestResultRender();
	}

	setupValueObject(value, obBoardingStatus) {
		this.value = {
			...this.data,
			value: value
				? {
						...value,
						onboardingStatus: obBoardingStatus
				  }
				: undefined
		};
		if (this.value) {
			this.dependentQuestion = this.value.dependentQuestion;
		}
	}

	createSelectComponent(resultDetails) {
		this.parkRoleSelector = new SelectComponent(this.parkFinderRoleElement, {
			data: {
				...SELECTOR_DATA,
				value: this.data?.role
			}
		});
		this.parkRoleSelector.onChange((data) => {
			const dataObject = {
				...data,
				venueID: resultDetails?.venueID || resultDetails?.id
			};
			this.roleChangeHandler(dataObject);
		});
	}

	afterAutoSuggestResultRender() {
		const suggestionAutoSuggestResult = SelectorEngine.findOne(
			'.lta-autosuggest-input-result',
			this.parkFinderSearchResult
		);
		this.editRoleButton = SelectorEngine.findOne('.lta-park-search--edit-role', suggestionAutoSuggestResult);
		this.removeVenueButton = SelectorEngine.findOne('.lta-park-search--remove-venue', suggestionAutoSuggestResult);
		this.roleElement = SelectorEngine.findOne('.lta-autosuggest-input-result_park-role', this.parkFinderSearchResult);

		EventHandler.on(this.editRoleButton, CLICK_EVENT, () => {
			this.toggleRoleSelector();
		});

		EventHandler.on(this.removeVenueButton, CLICK_EVENT, (event) => {
			this.removeButtonClickHandler(event);
		});
	}

	toggleRoleSelector() {
		this.roleElement?.classList.add(HIDDEN_CLASS);
		this.roleElement?.classList.remove(FLEX_CLASS);
		this.editRoleButton?.classList.add(HIDDEN_CLASS);
		this.parkFinderRoleElement?.classList.remove(HIDDEN_CLASS);
	}

	removeButtonClickHandler() {
		this.confirmationModal.toggleModal(true);
	}

	renderAutoSuggestResult(parkDetail) {
		return `<div class="lta-autosuggest-input-result u-mb-4">
					<div class="u-mb-4">
						${this.renderInstructionLabel(this.data.instructionText)}
					</div>
					<div class="u-px-3 u-py-2 u-bg-background-blue u-rounded">
						<div class="lta-autosuggest-input-result_park-name u-h6">${parkDetail.venue}</div>
						<div class="u-body2 u-mb-3">${parkDetail?.address?.postCode}</div>
                        ${
													parkDetail?.role
														? `<div class="lta-autosuggest-input-result_park-role u-body2 u-mb-3 u-flex">
                            <div class="u-mr-2">Role:</div>
                            <div><b>${parkDetail?.role}</b></div>
                        </div>`
														: ''
												}
                        <div>
                            <button type="button" class="lta-btn lta-btn--xs lta-btn--petite lta-btn--icon lta-btn--icon-before lta-park-search--edit-role u-mr-0 md:u-mr-2">
                                <svg class="lta-icon js-lta-text-input--btn-icon u-mr-1" width="1.5em" height="1.5em" fill="currentColor" alt="search" aria-hidden="true">
                                    <use xlink:href="/static/images/icons/lta-icons.svg#pencil-fill"></use>
                                </svg>Edit Role
                            </button>
                            <button type="button" class="lta-btn lta-btn--xs lta-btn--petite lta-btn--icon lta-btn--icon-before lta-park-search--remove-venue">
                                <svg class="lta-icon js-lta-text-input--btn-icon u-mr-1" width="1.5em" height="1.5em" fill="currentColor" alt="search" aria-hidden="true">
                                    <use xlink:href="/static/images/icons/lta-icons.svg#close-circle"></use>
                                </svg>Remove Venue
                            </button>
                        </div>
					<div>
				</div>`;
	}

	renderInstructionLabel(instructionLabel) {
		return instructionLabel ? `<span class="lta-text-input__label-instruction">${instructionLabel}</span>` : '';
	}

	setupValidateObject() {
		this.formElementData = {
			element: this.searchInputFieldContainerElement,
			formElement: this.searchInputFieldElement,
			errorMessage: this.data.errorMessage,
			inputType: InputTypes.SELECTOR_INPUT,
			hasIcon: false
		};
	}

	validate() {
		return this.parkRoleSelector ? this.parkRoleSelector.validate() : true;
	}
}
export default AffiliatedVenueSearch;
